import InspectionComment from './InspectionComment.container';
export default InspectionComment;
